import { render } from "./PeppolCompany.vue?vue&type=template&id=4853d6a0&scoped=true"
import script from "./PeppolCompany.vue?vue&type=script&lang=js"
export * from "./PeppolCompany.vue?vue&type=script&lang=js"

import "./PeppolCompany.vue?vue&type=style&index=0&id=4853d6a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4853d6a0"]])

export default __exports__